import {
  buttonWhite,
  orangeShades,
  primaryColors,
  transparentColors
} from '@assets/styles/helpers/colors.styles'

// The same fill avatars have in the tables (`Table.styles.ts`).
export const avatarStyles = {
  width: '2rem',
  height: '2rem',
  flexShrink: 0,
  background: transparentColors.whiteShade3,
  color: primaryColors.white
}

export const getAccountButtonStyles = (
  active?: boolean,
  collapsed?: boolean
) => ({
  boxSizing: 'border-box',
  minWidth: 0,
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '0.5rem',
  // The chevron stands under the sidebar's submenu chevrons, which sit 0.4rem
  // in from the same edge (`.menuChevron`). Collapsed, there is no chevron.
  padding: collapsed ? '0.25rem' : '0.25rem 0.4rem 0.25rem 0.25rem',
  color: buttonWhite.text.font,
  borderRadius: '0.5rem',
  textTransform: 'none',
  background: active ? transparentColors.whiteShade2 : 'transparent',
  '&:hover': {
    background: active
      ? transparentColors.whiteShade2
      : transparentColors.whiteShade1
  },
  '&:active': {
    background: transparentColors.whiteShade3
  },
  // `index.css` still puts the system focus ring on every button.
  '&:focus': {
    outline: 'none'
  },
  '&:focus-visible': {
    outline: `2px solid ${orangeShades.shade1}`,
    outlineOffset: '-2px'
  }
})
